/* botao de copiar dos canais do suporte (sections/nt-fx-suporte.liquid): copia o e-mail ou o numero do cartao e
   troca o rotulo por "copiado" por 2s. sem a area de transferencia (pagina sem https, navegador antigo ou permissao
   negada) seleciona o texto do ticket, para o visitante copiar na mao. o clique e escutado no documento: vale para
   as duas instancias da secao e para a secao recarregada no editor de temas */
(function () {
  if (window.ntSupCopiar) return;
  window.ntSupCopiar = true;

  var TEMPO = 2000;

  function seleciona(el) {
    if (!el || !window.getSelection) return false;
    var sel = window.getSelection();
    var faixa = document.createRange();
    faixa.selectNodeContents(el);
    sel.removeAllRanges();
    sel.addRange(faixa);
    try {
      return document.execCommand('copy');
    } catch (e) {
      return false;
    }
  }

  function avisa(botao) {
    var rotulo = botao.querySelector('[data-nt-sup-rotulo]');
    clearTimeout(botao.ntSupVolta);
    botao.classList.add('is-copiado');
    if (rotulo) rotulo.textContent = botao.getAttribute('data-copiado') || '';
    botao.ntSupVolta = setTimeout(function () {
      botao.classList.remove('is-copiado');
      if (rotulo) rotulo.textContent = botao.getAttribute('data-copiar') || '';
    }, TEMPO);
  }

  function copia(botao) {
    var valor = botao.getAttribute('data-valor') || '';
    var ticket = botao.closest('.s-sup__ticket');
    var texto = ticket && ticket.querySelector('[data-nt-sup-valor]');
    var plano = function () {
      if (seleciona(texto)) avisa(botao);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(valor).then(function () { avisa(botao); }, plano);
    } else {
      plano();
    }
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest && e.target.closest('[data-nt-sup-copiar]');
    if (botao) copia(botao);
  });
})();
